module.exports = __webpack_public_path__ + "img/program.f120d402.svg";